var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon",class:( _obj = {}, _obj[("icon_" + _vm.name)] = true, _obj[("icon_size-" + _vm.size)] = true, _obj.icon_color = !!_vm.color, _obj ),style:(_vm.styles)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }